var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "unlocked") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-304",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "unlocked",
    fillRule: "nonzero",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,20 L12,14.0001134 C12,7.37225697 17.3717454,2 24,2 C30.6288809,2 36,7.36945947 36,14.0001134 C36,15.1046829 35.1045695,16.0001134 34,16.0001134 C32.8954305,16.0001134 32,15.1046829 32,14.0001134 C32,9.57887525 28.4200185,6 24,6 C19.5809697,6 16,9.58131071 16,14.0001134 L16,20 L35.9999809,20 C38.7617853,20 41,22.2388819 41,25.0013869 L41,40.9986131 C41,43.7595904 38.7584642,46 35.9999809,46 L12.0000191,46 C9.23821469,46 7,43.7611181 7,40.9986131 L7,25.0013869 C7,22.240416 9.24152541,20.0000104 12,20 Z M11,25.0013869 L11,40.9986131 C11,41.5522459 11.4476206,42 12.0000191,42 L35.9999809,42 C36.5497751,42 37,41.5500013 37,40.9986131 L37,25.0013869 C37,24.4477541 36.5523794,24 35.9999809,24 L12.0000191,24 C11.4502249,24 11,24.4499987 11,25.0013869 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.51a383228faabc5b9edba1f9b83d6e58.svg";
export { ForwardRef as ReactComponent };